import React from "react";
import loadable from "@loadable/component";
import HeroSection from "../components/shared/HeroSection";

const VideoDemoSection = loadable(() =>
  import("../components/shared/VideoDemoSection")
);
const FeaturesSection = loadable(() =>
  import("../components/shared/FeaturesSection")
);
const ReferSection = loadable(() =>
  import("../components/shared/ReferSection")
);
const ContactUsSection = loadable(() =>
  import("../components/shared/ContactUsSection")
);
const FAQSection = loadable(() => import("../components/shared/FAQSection"));
const HowToHostSection = loadable(() =>
  import("../components/shared/HowToHostSection")
);
const ExplanationSection = loadable(() =>
  import("../components/shared/ExplanationSection")
);
const TestimonialSection = loadable(() =>
  import("../components/shared/TestimonialSection")
);
const EarningsSection = loadable(() =>
  import("../components/home-page/EarningsSection")
);

const HomePage = () => {
  return (
    <>
      <HeroSection
        title={'Earn passive income renting (a tiny fraction of) your internet'}
        description={'Power the future of smart technology. Install a tiny, secure smart IoT device hotspot. Earn $100 per year.'}
        highlight={'Earn'}
      />
      <VideoDemoSection />
      <FeaturesSection
        title={'Get $100 per year to connect it and forget it'}
        description={'You\'re supporting scooters, package delivery, and other smart devices in your neighborhood. No costs or impact on your internet speed.'}
        highlight={'$100 per year'}
      />
      <ReferSection
        title={'Refer a friend? Get paid again (and again)'}
        description={'Invite as many people as you like. You earn $120 per year for each referral. They earn $100 for installing a hotspot. Presto, everybody wins.'}
        highlight={'friend?'}
      />
      <TestimonialSection
        title={'Trusted by homeowners, renters, & business owners'}
        highlight={'Trusted by'}
      />
      <EarningsSection />
      <HowToHostSection
        title={'How to become a CoastFi host'}
        highlight={'CoastFi host'}
      />
      <ExplanationSection
        firstTitle={() => <>Easy for {document.body.clientWidth > 768 && <br />} non-technical people</>}
        firstDescription={`Installation doesn't take an engineer, we promise. Each hotspot is shipped through the mail with simple instructions. Get paid as soon as you connect it to your WiFi network with the easy to use CoastFi App (available on iOS & Android devices).`}
        secondTitle={'Earn extra with referrals'}
        secondDescription={() => <>CoastFi is <strong>always free</strong> for everyone. Earn $100 per year for your hotspot plus $120 per year for each successful referral you make to friends and family. Just apply, get approved, and earn your first $100 immediately.</>}
      />
      <FAQSection
          items={[
            {
              title: 'Okay, but how does CoastFi make money?',
              answer: 'We are an "antenna company" that provides coverage for IoT Devices, similar to how AT&T, Verizon, and Sprint rent antennas from other companies to provide cellular coverage. We get paid by IoT companies when their devices ping convenient hotspots. You never pay us a dime, no exceptions.',
              isExp: true
            },
            {
              title: 'What if I install a hotspot but then I need to return it?',
              answer: 'No problem! A hotspot can be returned at any time. Simply email us at help@coastfi.com or call us at 888-COAST81. We will provide you return instructions and a return shipping label for the hotspot, at no cost to you.'
            },
            {
              title: `Are you sure it's secure?`,
              answer: 'Yes. Only devices authorized to access the network can use the hotspot, meaning you are protected and secure from unauthorized third-party use. Plus, our hotspots receive firmware updates on a regular basis to maintain strict privacy standards and intrusion defense.'
            }
          ]}
      />
      <ContactUsSection
        title={`We've got a network to build and we need your help`}
        description={'Contribute to a safer, smarter future. Fill out our short form to see if you qualify.'}
        highlight={'your help'}
        calendly={'https://calendly.com/-coastfi-/registration-call'}
      />
    </>
  );
};

export default HomePage;
